import React from "react";

import { connect } from "react-redux";
import { Link } from "react-router-dom";

import * as actions from "../../../../store/actions";
import {
  PROFILE_COMPLETE,
  QR_CODE,
  getOnboardingPath,
  getDashboardPath,
} from "../../../../constants";

import Button from "../../../../components/formElements/button/Button";
import Modals from "../../../../components/uiElements/popupModal/modal";
import { getRole, getUserData, saveRole } from "../../../../utils/localStorage";

import "./index.css";

const ProfileComplete = ({ history, logout, getUserDetailId }) => {
  const [isOpen, setIsOpen] = React.useState();
  let openModal = value => {
    setIsOpen(value);
  };
  let closeModal = () => {
    setIsOpen(undefined);
  };
  return (
    <div className="container text-center" style={{ maxWidth: 550 }}>
      <Modals
        isOpen={!!isOpen}
        onRequestClose={() => closeModal}
        className="model"
        styles={{
          content: {
            position: "absolute",
            width: "582px",
            height: "481px",
            marginleft: "392px",
            borderRadius: "10px",
          },
        }}
      >
        <React.Fragment>
          <button
            onClick={closeModal}
            className="close modalCloseBtn"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <img src={QR_CODE} alt="" className="qr image mb-n4" />
          <div>
            <p className="mx-auto text-center denyAppointmentText">
              Scan the QR code to download the app
            </p>
          </div>
        </React.Fragment>
      </Modals>
      <p className="qr header mb-5">
        <span className="change-primary-color mx-auto">
          Yay! You have successfully
          <br /> created your patient profile!
        </span>
      </p>
      <img src={PROFILE_COMPLETE} alt="" />
      <p style={{ fontWeight: 500 }}>
        Scan the QR code to download our mobile app and start searching for
        physicians.
      </p>
      <Button
        className="w-75 mb-3"
        label="Show QR Code"
        onClick={() => openModal(true)}
      />
      <div style={{ marginTop: "89px" }}>
        <Link
          className="qr link"
          onClick={() => history.push(getOnboardingPath("/step1"))}
        >
          Back to Profile
        </Link>
        {getRole() === "PATIENT" &&
          getUserData()?.accepted_role?.includes("PHYSICIAN") && (
            <>
              <Link
                className="qr link"
                onClick={() => {
                  saveRole("PHYSICIAN");
                  getUserDetailId(() => {
                    history.push(
                      getUserData()?.accepted_role?.includes("PHYSICIAN")
                        ? getDashboardPath("/appointments")
                        : getOnboardingPath("/create-profile")
                    );
                    window.location.reload();
                  });
                }}
              >
                Login as Physician
              </Link>
            </>
          )}
        <Link className="qr logout-link" onClick={() => logout()}>
          Sign out
        </Link>
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(actions.logout()),
  getUserDetailId: cb => dispatch(actions.getUserDetailIdAction(cb)),
});

export default connect(undefined, mapDispatchToProps)(ProfileComplete);
